import { useEffect, useState } from "react";
import { Button, openModal } from "risa-oasis-ui_v2";
import { getStateName } from "../../../../../../../shared/enums/usStates";
import { DetailsCard } from "../../../../../../components/detailsCard/detailsCard";
import HealthCareInvitationModal from "../../../../../../components/modals/healthCareInvitationModal/healthCareInvitationModal";
import NewFacilityModal from "../../../../../../components/modals/newFacilityModal/newFacilityModal";
import { HealthCareFacilityModel } from "../../../../../../data-model/healthFacility";
import DashboardTypeChip from "../dashboardTypeChip/dashboardTypeChip";

const HealthCareDetails = (props: {
  singleHealthCareData: HealthCareFacilityModel;
  showChip?: boolean;
  variant?: "med_onc" | "pharmacy" | "common";
}) => {
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [openInvitationModal, setOpenInvitationModal] =
    useState<boolean>(false);
  const stateName = () => {
    if (props?.singleHealthCareData?.Address?.State) {
      const stateNameRetreived = getStateName(
        props?.singleHealthCareData?.Address?.State,
      );
      return stateNameRetreived ? stateNameRetreived : "-";
    } else {
      return "-";
    }
  };

  const generateCommunicationDetails = () => {
    if (!props?.singleHealthCareData) return [];
    return [
      {
        header: "Street Address",
        text: props?.singleHealthCareData?.Address?.StreetAddress || "-",
      },
      {
        header: "City",
        text: props?.singleHealthCareData?.Address?.City || "-",
      },
      {
        header: "State",
        text: stateName(),
      },
      {
        header: "Zip Code",
        text: props?.singleHealthCareData?.Address?.ZIP || "-",
      },
      {
        header: "Country",
        text: props?.singleHealthCareData?.Address?.Country || "USA",
      },
      {
        header: "Phone Number",
        text: props?.singleHealthCareData?.PhoneNumber || "-",
      },
      {
        header: "RISA Phone Number",
        text: props?.singleHealthCareData?.RisaPhoneNumber || "-",
      },
      {
        header: "RISA Fax Number",
        text: props?.singleHealthCareData?.RisaFaxNumber || "-",
      },
    ];
  };
  useEffect(() => {
    if (openEditModal) {
      openModal("new-facility-modal");
    }
  }, [openEditModal]);

  useEffect(() => {
    if (openInvitationModal) {
      openModal("invitation-modal");
    }
  }, [openInvitationModal]);

  return (
    <>
      <div className="hc-detail__container">
        <div className="hc-detail__header flex items-center gap-3">
          <span>{props?.singleHealthCareData?.Name || ""}</span>
          {props.showChip && (
            <DashboardTypeChip
              dashboardType={props.singleHealthCareData?.dashboard_type}
            />
          )}
        </div>
        <div className="hc-detail__content">
          <div className="hc-detail__primary">
            <div className="hc-detail__primary--text">Primary Details</div>
            <DetailsCard
              details={[
                {
                  header: "NPI",
                  text: props?.singleHealthCareData?.NPI || "-",
                },
                {
                  header: "Tax Id",
                  text: props?.singleHealthCareData?.TaxID || "-",
                },
                {
                  header: "FHIR ID",
                  text: props?.singleHealthCareData?.FhirId || "-",
                },
                {
                  header: "FHIR Client ID",
                  text: props?.singleHealthCareData?.fhir_client || "-",
                },
              ]}
              elementsInOneRow={2}
              showBorder={true}
            />
          </div>
          <div className="hc-detail__communication">
            <div className="hc-detail__communication--text">
              Communication Details
            </div>
            <DetailsCard
              details={generateCommunicationDetails()}
              elementsInOneRow={2}
              showBorder={true}
            />
          </div>
          <div className="hc-detail__cta">
            <Button
              disabled={false}
              children={"Send Invite"}
              onClick={() => {
                setOpenInvitationModal(true);
              }}
              buttonType={"primary"}
              size={"medium"}
            />
            <Button
              disabled={false}
              children={"Edit Details"}
              onClick={() => {
                setOpenEditModal(true);
              }}
              buttonType={"secondary"}
              size={"medium"}
            />
          </div>
        </div>
      </div>
      {openEditModal && (
        <NewFacilityModal
          data={props?.singleHealthCareData}
          onModalClose={(status) => setOpenEditModal(status)}
          type={"edit"}
          variant={props.variant}
        />
      )}
      {openInvitationModal && (
        <HealthCareInvitationModal
          facilityId={props?.singleHealthCareData?.DocId || ""}
          onModalClose={(status) => setOpenInvitationModal(status)}
        />
      )}
    </>
  );
};

export default HealthCareDetails;
